<script>
  import AudioPlayer from './AudioPlayer.svelte';
</script>


<!-- Section 10 -->
<section id="section-11" class="section-divider-ipg">
  <h3 class="heading-2-ipg">Section Ten</h3>
  <h3 class="heading-3-ipg">Indeclinables (<span class="italic-w-ipg">nipāta</span>)</h3>
  <p class="paragraph-1-ipg">
    <span class="italic-w-ipg"></span>
  </p>

  <p class="paragraph-1-ipg">
    Indeclinables are words, which carry their own meaning and are placed either before or behind the noun they refer to. They could be compared to adverbs, prepositions or conjunctions in other languages; often they are used adverbially. They are of frequent occurrence therefore a good knowledge of these may be useful.
  </p>

  <AudioPlayer audioURL={"/12-Nipata-pages-36-39.mp3"} />		


  <!-- table 1, left header and top-row header -->
  <div class="responsive-table-ipg table-regular-ipg width-table-1">
    <table class="vowel-list-2 table-regular-ipg width-table-1"> 
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">āma</span></td>	
        <td class="list-chart-3-ipg">yes</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">adho</span></td>	
        <td class="list-chart-3-ipg">below</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">adhunā</span></td>	
        <td class="list-chart-3-ipg">now, just now</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">aho</span></td>	
        <td class="list-chart-3-ipg">ah!</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ajja</span></td>	
        <td class="list-chart-3-ipg">today</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ajjhattaṃ</span></td>	
        <td class="list-chart-3-ipg">internally</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">alaṃ</span></td>	
        <td class="list-chart-3-ipg">enough</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">anantaraṃ</span></td>	
        <td class="list-chart-3-ipg">immediately following</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">aññathā</span></td>	
        <td class="list-chart-3-ipg">otherwise</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">aññatra</span></td>	
        <td class="list-chart-3-ipg">except for, apart from</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">antarā</span></td>	
        <td class="list-chart-3-ipg">within, between</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">anulomaṃ</span></td>	
        <td class="list-chart-3-ipg">in natural order</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">anupādā</span></td>	
        <td class="list-chart-3-ipg">without attachment</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">anupubbena</span></td>	
        <td class="list-chart-3-ipg">in due course, in succession</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">aparaṃ</span></td>	
        <td class="list-chart-3-ipg">further, afterwards</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">api</span></td>	
        <td class="list-chart-3-ipg">also</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">api ca</span></td> 
        <td class="list-chart-3-ipg">and also, nevertheless</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ativelaṃ</span></td>	
        <td class="list-chart-3-ipg">too long</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ativiya</span></td>	
        <td class="list-chart-3-ipg">very much</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">avidūre</span></td>	
        <td class="list-chart-3-ipg">near, not far</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ayoniso</span></td>	
        <td class="list-chart-3-ipg">erratically, unmethodically</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">bhūtapubbaṃ</span></td>	
        <td class="list-chart-3-ipg">formerly, once upon a time</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">bhiyyo</span></td>	
        <td class="list-chart-3-ipg">more</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ca</span></td>	
        <td class="list-chart-3-ipg">and</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ce</span></td>	
        <td class="list-chart-3-ipg">if</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ciraṃ</span></td>	
        <td class="list-chart-3-ipg">for a long time</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">dāni</span></td>	
        <td class="list-chart-3-ipg">now</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">dīghaṃ</span></td>	
        <td class="list-chart-3-ipg">long</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">dūrā</span></td>	
        <td class="list-chart-3-ipg">from far away</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">dūrato</span></td>	
        <td class="list-chart-3-ipg">in the distance</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">divā</span></td>	
        <td class="list-chart-3-ipg">by day</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ekantikena</span></td>	
        <td class="list-chart-3-ipg">finally</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ekato</span></td>	
        <td class="list-chart-3-ipg">on one side</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">etarahi</span></td>	
        <td class="list-chart-3-ipg">now, at present</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ettāvatā</span></td>	
        <td class="list-chart-3-ipg">to that extent</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ettha</span></td>	
        <td class="list-chart-3-ipg">here, in this case</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">eva</span></td>	
        <td class="list-chart-3-ipg">only, just</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">evaṃ</span></td>	
        <td class="list-chart-3-ipg">thus, so, yes</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">evameva</span></td>	
        <td class="list-chart-3-ipg">just so, likewise</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ha</span></td>	
        <td class="list-chart-3-ipg">indeed, truly</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">hi</span></td>	
        <td class="list-chart-3-ipg">for, because, though</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">idha</span></td>	
        <td class="list-chart-3-ipg">here, in this connection</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">iha</span></td>	
        <td class="list-chart-3-ipg">here, in this case</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">itthaṃ</span></td>	
        <td class="list-chart-3-ipg">in this way, thus</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">iva</span></td>	
        <td class="list-chart-3-ipg">like</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kacci</span></td>	
        <td class="list-chart-3-ipg">perhaps</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kadā</span></td>	
        <td class="list-chart-3-ipg">when</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kadā ci</span></td> 
        <td class="list-chart-3-ipg">	at any time</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kasmā</span></td>	
        <td class="list-chart-3-ipg">why? wherefore?</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kathaṃ</span></td>	
        <td class="list-chart-3-ipg">how?</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kattha</span></td>	
        <td class="list-chart-3-ipg">where?</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">khalu</span></td>	
        <td class="list-chart-3-ipg">indeed</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">khippaṃ</span></td>	
        <td class="list-chart-3-ipg">quickly</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kho</span></td>	
        <td class="list-chart-3-ipg">indeed</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kiṃ</span></td>	
        <td class="list-chart-3-ipg">why?</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kuhiṃ</span></td>	
        <td class="list-chart-3-ipg">where to?</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">kuto</span></td>	
        <td class="list-chart-3-ipg">whence?</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">mā</span></td>	
        <td class="list-chart-3-ipg">not</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">majjhe</span></td>	
        <td class="list-chart-3-ipg">in the middle</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">micchā</span></td>	
        <td class="list-chart-3-ipg">wrongly</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">nāma</span></td>	
        <td class="list-chart-3-ipg">by name, indeed</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">nānā</span></td>	
        <td class="list-chart-3-ipg">variously</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">na</span></td>	
        <td class="list-chart-3-ipg">not</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">na cirasseva</span></td> 
        <td class="list-chart-3-ipg">soon</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">no</span></td>	
        <td class="list-chart-3-ipg">not (emphatic)</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pāraṃ</span></td>	
        <td class="list-chart-3-ipg">thither, beyond</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">paṭilomaṃ</span></td>	
        <td class="list-chart-3-ipg">in reverse order</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pacchā</span></td>	
        <td class="list-chart-3-ipg">afterwards</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pana</span></td>	
        <td class="list-chart-3-ipg">but, however, now</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">paraṃ</span></td>	
        <td class="list-chart-3-ipg">after</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">parimukhaṃ</span></td>	
        <td class="list-chart-3-ipg">in front</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pe</span></td>	
        <td class="list-chart-3-ipg">and so on, etc.</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pi</span></td>	
        <td class="list-chart-3-ipg">also </td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">piṭṭhito</span></td>	
        <td class="list-chart-3-ipg">behind</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pubbe</span></td>	
        <td class="list-chart-3-ipg">before</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">puna</span></td>	
        <td class="list-chart-3-ipg">again</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">punappunaṃ</span></td>	
        <td class="list-chart-3-ipg">again and again</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">purato</span></td>	
        <td class="list-chart-3-ipg">in front of</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">pure</span></td>	
        <td class="list-chart-3-ipg">before, in advance</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sādhu</span></td>	
        <td class="list-chart-3-ipg">well</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sāyaṃ</span></td>	
        <td class="list-chart-3-ipg">in the evening</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sabbadā</span></td>	
        <td class="list-chart-3-ipg">always</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sabbathā</span></td>	
        <td class="list-chart-3-ipg">in all ways</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sabbato</span></td>	
        <td class="list-chart-3-ipg">all around</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sace</span></td>	
        <td class="list-chart-3-ipg">if</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sadā</span></td>	
        <td class="list-chart-3-ipg">always</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">saddhiṃ</span></td>	
        <td class="list-chart-3-ipg">with</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">saha</span></td>	
        <td class="list-chart-3-ipg">along with</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sakideva</span></td>	
        <td class="list-chart-3-ipg">once</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">samaṃ</span></td>	
        <td class="list-chart-3-ipg">equally, like</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">samantā</span></td>	
        <td class="list-chart-3-ipg">on all sides</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">santike</span></td>	
        <td class="list-chart-3-ipg">near</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">sayaṃ</span></td>	
        <td class="list-chart-3-ipg">oneself, self</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">seyyathā</span></td>	
        <td class="list-chart-3-ipg">as, just like</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">seyyathidaṃ</span></td>	
        <td class="list-chart-3-ipg">as follows</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">seyyo</span></td>	
        <td class="list-chart-3-ipg">better</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tāva</span></td>	
        <td class="list-chart-3-ipg">so much, so long</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tadā</span></td>	
        <td class="list-chart-3-ipg">then</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tadagge</span></td>	
        <td class="list-chart-3-ipg">since then</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">taggha</span></td>	
        <td class="list-chart-3-ipg">certainly</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tasmā</span></td>	
        <td class="list-chart-3-ipg">therefore</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tathā</span></td>	
        <td class="list-chart-3-ipg">thus</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tato</span></td>	
        <td class="list-chart-3-ipg">thence, then</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tatra</span></td>	
        <td class="list-chart-3-ipg">there, in this connection</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tattha</span></td>	
        <td class="list-chart-3-ipg">there, in that connection</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tayidaṃ</span></td>	
        <td class="list-chart-3-ipg">with reference to this</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tiriyaṃ</span></td>	
        <td class="list-chart-3-ipg">horizontally</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">tuṇhī</span></td>	
        <td class="list-chart-3-ipg">silent, silently</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">uddhaṃ</span></td>	
        <td class="list-chart-3-ipg">above</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">upari</span></td>	
        <td class="list-chart-3-ipg">on top of</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">uttari</span></td>	
        <td class="list-chart-3-ipg">beyond, further, more</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">vā</span></td>	
        <td class="list-chart-3-ipg">or, either</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">va</span></td>	
        <td class="list-chart-3-ipg">like</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">vata</span></td>	
        <td class="list-chart-3-ipg">surely, indeed!</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">ve</span></td>	
        <td class="list-chart-3-ipg">surely (poetic)</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">viya</span></td>	
        <td class="list-chart-3-ipg">like</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yāva</span></td>	
        <td class="list-chart-3-ipg">as far as, up to, until</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yāvatā</span></td>	
        <td class="list-chart-3-ipg">as far as</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yadā</span></td>	
        <td class="list-chart-3-ipg">when</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yadagge</span></td>	
        <td class="list-chart-3-ipg">since</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yadi</span></td>	
        <td class="list-chart-3-ipg">whether</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yadidaṃ</span></td>	
        <td class="list-chart-3-ipg">such as, as</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yasmā</span></td>	
        <td class="list-chart-3-ipg">because, since</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yathā</span></td>	
        <td class="list-chart-3-ipg">as, how</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yathābhūtaṃ</span></td>	
        <td class="list-chart-3-ipg">as it really is</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yato</span></td>	
        <td class="list-chart-3-ipg">because</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yatra</span></td>	
        <td class="list-chart-3-ipg">where</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yattha</span></td>	
        <td class="list-chart-3-ipg">where</td>
      </tr>
      <tr>
        <td class="list-chart-3-ipg"><span class="italic-w-ipg">yoniso</span></td>	
        <td class="list-chart-3-ipg">methodically</td>
      </tr>
    </table>
  </div>
  <!-- No Footnotes for Section 10 -->

</section>
<!-- /Section 10 -->



<style>
  div {
    height: 300px;
    overflow-y: scroll;
    transform: rotateX(0deg);
  }

  table {
    transform: rotateX(0deg);
  }
</style>